import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthToken, getStoredUser } from '../utils/authStorage';

const ProtectedRoute = ({ children, allowedRoles = null }) => {
  const token = getAuthToken();
  const user = getStoredUser();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const role = user?.role || 'viewer';
    if (!allowedRoles.includes(role)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;



